<template>
    <div>
        
        <router-view></router-view>
        <footBottom></footBottom>
    </div>
</template>
<script>
import footBottom from '@/components/footBottom'
export default {
    components:{
        footBottom
    },
    data() {
        return {
            
        }
    },
    methods: {
        
    },
    
}
</script>




// WEBPACK FOOTER //
// src/pages/index.vue